import { render } from "./PanelPublicistaLandingsEfectivas.vue?vue&type=template&id=a9e40160&scoped=true"
import script from "./PanelPublicistaLandingsEfectivas.vue?vue&type=script&lang=js"
export * from "./PanelPublicistaLandingsEfectivas.vue?vue&type=script&lang=js"

import "./PanelPublicistaLandingsEfectivas.vue?vue&type=style&index=0&id=a9e40160&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e40160"]])

export default __exports__